// extracted by mini-css-extract-plugin
export var actionText = "_p6-4";
export var container = "_p6-0";
export var leftSection = "_p6-1";
export var rightSection = "_p6-2";
export var settingsButton = "_p6-6";
export var settingsIcon = "_p6-7";
export var shortcut = "_p6-5";
export var shortcutGroup = "_p6-3";